import React, { Fragment, useState, useEffect } from 'react'
import { Autocomplete, Box, CardMedia, FormControl, Grid, IconButton, InputLabel, MenuItem, TextField, Typography } from '@mui/material'
import Colors from '../../../Assets/Styles/Colors'
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs'
import { baseUrl } from '../../../../axios'
import { DeleteForever, KeyboardArrowLeft, PhotoLibrary } from '@mui/icons-material'
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices'
import BannerServices from '../../../Api/Banner/BannerServices'
import { PrimaryButton } from '../../../Components/Buttons'
import { SuccessToaster } from '../../../Components/Toaster/Toaster'
import { useNavigate } from 'react-router-dom'
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog'
import AdBooksServices from '../../../Api/AdBooks/AdBooksServices'
import SelectField from '../../../Components/Fields/SelectField'
import { InputField } from '../../../Components/Fields/TextFields'
import { useForm } from 'react-hook-form'

function UploadBannerAdb() {
  const [image, setImage] = useState("");
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [bannerImages, setBannerImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const navigate = useNavigate();
  const { register, formState: { errors }, handleSubmit, reset } = useForm();

  const options = [
    {
      _id: 1,
      name: "URL"
    },
    {
      _id: 2,
      name: "Blog"
    },
  ];

  const getAllBanners = async () => {
    try {
      const result = await BannerServices.getAllBanners();
      // console.log(result);
      const filteredBanners = result?.data?.banners.filter((item) => item.type == "adbook");
      setBannerImages(filteredBanners);
    }
    catch (e) {
      console.log(e);
    }
  };

  const getAllBlogs = async () => {
    try {
      const result = await AdBooksServices.getAllAdbooks(
        "",
        "",
        1,
        25,
        "adbook",
        true
      )
      if (result.responseCode == 200) {
        const arrOfObj = result?.data?.blogs?.map((item) => ({ id: item?._id, title: item?.title }));
        setBlogs(arrOfObj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  };

  const handleDelete = async () => {
    try {
      const result = await BannerServices.deleteBanner(id);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message);
      }
    } catch (err) {
      console.log(err)
    } finally {
      getAllBanners();
    }
  }

  const bannerImage = async (formData) => {
    setLoading(true);
    const obj = {
      imageUrl: image,
      type: "adbook"
    }
    if (selectedOption?.id == 1) {
      obj.url = formData?.url
    } else {
      obj.blogId = selectedBlog?.id
    }
    try {
      const result = await BannerServices.createBanner(obj);
      if (result.responseCode == 200) {
        SuccessToaster(result.message);
        setImage("");
        setSelectedOption(null);
        setSelectedBlog(null);
        reset();
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
      getAllBanners();
    }
  }

  useEffect(() => {
    getAllBanners();
    getAllBlogs();
  }, [])

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={handleDelete}
        title={"Delete Banner"}
        btn={"Delete"}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Upload Banner Image
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Upload Banner Image"]} />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          }}
        >
          <Box sx={{ mt: "16px" }}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Box
                  sx={{
                    height: "180px",
                    border: image !== "" ? "none" : "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                    ":hover": {
                      borderColor: image !== "" ? "transparent" : "#1F1F1F"
                    },
                    backgroundColor: Colors.white,
                  }}
                >
                  {image !== "" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      <CardMedia
                        component={"img"}
                        src={baseUrl + image}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover"
                        }}
                      />
                    </Box>
                  ) : (
                    <Fragment>
                      <InputLabel
                        htmlFor="image-input"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px"
                        }}
                      >
                        <PhotoLibrary sx={{ fontSize: "36px" }} />
                        <Typography>
                          Upload Image
                        </Typography>
                      </InputLabel>
                      <input
                        id="image-input"
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileUpload(e.target.files[0])}
                        style={{ display: "none" }}
                      />
                    </Fragment>
                  )}
                </Box>
              </Grid>
              <Grid item md={6}>
                <Grid
                  container
                  spacing={2}
                  component={"form"}
                  onSubmit={handleSubmit(bannerImage)}
                >
                  <Grid item md={12}>
                    <FormControl fullWidth>
                      <SelectField
                        setState={(item, name) => {
                          setSelectedOption({ id: item, name: name });
                        }}
                        stateValue={selectedOption?.name}
                        data={options}
                        label={"Select Option"}
                      />
                    </FormControl>
                  </Grid>
                  {selectedOption && (
                    selectedOption?.id == 1 ? (
                      <Grid item md={12}>
                        <Box>
                          <InputField
                            label={"Enter URL"}
                            register={register("url", {
                              required: "Please enter an url"
                            })}
                            error={errors?.url?.message}
                            helperText={errors?.url?.message}
                          />
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item md={12}>
                        <Box>
                          <FormControl fullWidth>
                            <Autocomplete
                              options={blogs}
                              renderOption={(props, option) =>
                                <MenuItem {...props} key={option.id} value={option.id}>
                                  {option.title}
                                </MenuItem>
                              }
                              getOptionLabel={(option) => option.title}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setSelectedBlog(newValue);
                                }
                              }}
                              renderInput={(params) => <TextField {...params} label="Blog Title" />}
                            />
                          </FormControl>
                        </Box>
                      </Grid>
                    )
                  )}
                  <Grid item md={12}>
                    <Box>
                      <PrimaryButton
                        type={"submit"}
                        fullWidth={true}
                        title={"Submit"}
                        loading={loading}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ backgroundColor: Colors.white, p: 2 }}>
            <Grid container spacing={3}>
              {bannerImages.map((item, i) => (
                <Grid key={i} item md={6}>
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component={"img"}
                      src={baseUrl + item.imageUrl}
                      sx={{
                        width: "100%",
                        height: "210px",
                        objectFit: "contain"
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-32px",
                        right: 0
                      }}
                    >
                      <IconButton onClick={() => { setOpen(true); setId(item?._id) }}>
                        <DeleteForever />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Fragment>
  )
}

export default UploadBannerAdb